<!--
  Вкладка ЭДО в карточке заказа.
  Показывает только документы, связанные с заказом через order_id,
  и использует общую кнопку создания ЭДО-документа из заказа.
-->
<template>
  <div class="card edo-documents-container">
    <div class="edo-documents-wrapper">
      <div class="edo-documents-header">
        <div>
          <h3 class="header-title">ЭДО</h3>
          <p class="edo-documents-subtitle">
            Электронные документы, связанные с текущим заказом
          </p>
        </div>
        <EdoCreateDocumentButton
          icon="addSquare"
          v-if="showCreateButton"
          :source-order-id="orderId"
          :source-organization-inn="sourceOrganizationInn"
          :source-return-tab="sourceReturnTab"
          label="Создать"
        />
      </div>

      <div
        v-if="documents.length === 0 && !documentsLoading"
        class="edo-documents-empty"
      >
        Документов пока нет
      </div>

      <EdoDocumentsTable
        v-else
        ref="orderEdoDocumentsTable"
        :documents="documents"
        :pagination="pagination"
        :loading="documentsLoading"
        @page-change="loadDocuments"
      />
    </div>
  </div>
</template>

<script>
import { useEdoDocumentStore } from "@/stores/edoDocumentStore";

import EdoCreateDocumentButton from "@/components/Edo/CreateDocumentButton.vue";
import EdoDocumentsTable from "@/components/Edo/DocumentsTable.vue";

const EMPTY_PAGINATION = {
  page: 1,
  pages: 1,
  series: [],
  next: null,
  prev: null,
  count: 0,
  limit: 40,
};

export default {
  name: "OrderEdoDocumentsTab",

  components: {
    EdoCreateDocumentButton,
    EdoDocumentsTable,
  },

  props: {
    orderId: {
      type: [String, Number],
      required: true,
    },
    showCreateButton: {
      type: Boolean,
      default: true,
    },
    sourceOrganizationInn: {
      type: [String, Number],
      default: null,
    },
    sourceReturnTab: {
      type: String,
      default: "edo_documents",
    },
  },

  emits: ["count-change"],

  data() {
    return {
      documents: [],
      pagination: { ...EMPTY_PAGINATION },
    };
  },

  computed: {
    edoDocumentStore() {
      return useEdoDocumentStore();
    },

    documentsLoading() {
      return this.edoDocumentStore.isLoading;
    },
  },

  watch: {
    orderId() {
      this.loadDocuments();
    },
  },

  mounted() {
    this.loadDocuments();
  },

  methods: {
    async loadDocuments(page = null) {
      const pageNumber = parseInt(page) || 1;
      const result = await this.edoDocumentStore.fetchDocuments({
        "q[order_id]": this.orderId,
        page: pageNumber,
      });

      this.documents = result?.documents || [];
      this.pagination = result?.pagination || { ...EMPTY_PAGINATION };
      this.$emit("count-change", this.pagination.count || 0);
    },

  },
};
</script>

<style scoped>
.edo-documents-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: var(--base-out-indent);
}

.edo-documents-subtitle {
  margin: 4px 0 0;
  color: #6b7280;
  font-size: 13px;
}

.edo-documents-empty {
  color: #6b7280;
  text-align: center;
  padding: 32px 0;
}

@media (max-width: 768px) {
  .edo-documents-header {
    flex-direction: column;
    gap: 15px;
    justify-content: flex-start;
    align-items: flex-start;
  }
}
</style>
